export const LIB_VERSION = '18.2.1'; // autogenerated
//# sourceMappingURL=version.js.map